import * as Actions from 'store/actions/app/treasury.actions'
import { addOrUpdateObjectInArray } from 'utils/add-or-update-object-in-array'
import { toggleIdInArray } from 'utils/toggle-id-in-array'

const initialState = {
  loading_branch_treasury_openings: false,
  branch_treasury_openings: [],

  loading_branch_treasury_closings: false,
  branch_treasury_closings: [],
  total_branch_treasury_closings: 0,

  saving_treasury_opening: false,
  saved_treasury_opening: false,
  saved_treasury_opening_data: null,

  voiding_treasury_opening_ids: [],
  voided_treasury_opening_ids: [],

  closing_treasury_opening_ids: [],
  closed_treasury_opening_ids: [],

  undoing_treasury_closing_ids: [],
  undone_treasury_closing_ids: [],
}

export default function treasuryReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.GET_BRANCH_TREASURY_OPENINGS: {
      return {
        ...state,
        loading_branch_treasury_openings: action.payload.loading,
        branch_treasury_openings: action.payload.data ?? state.branch_treasury_openings,
      }
    }
    case Actions.GET_BRANCH_TREASURY_CLOSINGS: {
      return {
        ...state,
        loading_branch_treasury_closings: action.payload.loading ?? state.loading_branch_treasury_closings,
        branch_treasury_closings: action.payload.items ?? state.branch_treasury_closings,
        total_branch_treasury_closings: action.payload.total ?? state.total_branch_treasury_closings,
      }
    }
    case Actions.SAVE_TREASURY_OPENING: {
      return {
        ...state,
        saving_treasury_opening: action.payload.saving ?? state.saving_treasury_opening,
        saved_treasury_opening: action.payload.saved ?? false,
        saved_treasury_opening_data: action.payload.data ?? null,
        branch_treasury_openings: action.payload.data
          ? addOrUpdateObjectInArray(state.branch_treasury_openings, action.payload.data, 'tesoreria_id', true)
          : state.branch_treasury_openings,
      }
    }
    case Actions.VOID_TREASURY_OPENING: {
      return {
        ...state,
        voiding_treasury_opening_ids: toggleIdInArray(state.voiding_treasury_opening_ids, action.payload.voiding_id),
        voided_treasury_opening_ids: toggleIdInArray(state.voided_treasury_opening_ids, action.payload.voided_id),
        branch_treasury_openings: state.branch_treasury_openings.filter(item => item.tesoreria_id !== action.payload.voided_id)
      }
    }
    case Actions.CLOSE_TREASURY_OPENING: {
      return {
        ...state,
        closing_treasury_opening_ids: toggleIdInArray(state.closing_treasury_opening_ids, action.payload.closing_id),
        closed_treasury_opening_ids: toggleIdInArray(state.closed_treasury_opening_ids, action.payload.closed_id),
        branch_treasury_openings: state.branch_treasury_openings.filter(item => item.tesoreria_id !== action.payload.closed_id),
        branch_treasury_closings: action.payload.data
          ? addOrUpdateObjectInArray(state.branch_treasury_closings, action.payload.data, 'tesoreria_id', true)
          : state.branch_treasury_closings,
      }
    }
    case Actions.UNDO_TREASURY_CLOSING: {
      return {
        ...state,
        undoing_treasury_closing_ids: toggleIdInArray(state.undoing_treasury_closing_ids, action.payload.undoing_id),
        undone_treasury_closing_ids: toggleIdInArray(state.undone_treasury_closing_ids, action.payload.undone_id),
        branch_treasury_closings: state.branch_treasury_closings.filter(item => item.tesoreria_id !== action.payload.undone_id),
        branch_treasury_openings: action.payload.data
          ? addOrUpdateObjectInArray(state.branch_treasury_openings, action.payload.data, 'tesoreria_id')
          : state.branch_treasury_openings,
      }
    }
    default: {
      return state
    }
  }
}
